import React from 'react';
import Services from '../components/Services';

const ServiceDetail = () => {
  return (
    <div className="pt-[72px]">
      <Services showCta={false} />
    </div>
  );
};

export default ServiceDetail;
